import React from 'react';
import { Modal, Button, Col } from 'react-bootstrap';
import './index.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import themeColors from '../../../utils/contants/theme-colors';

// labelBottone: scritta pulsante di destra ad esempio "salva", "elimina"
// coloreAzione: colore del pulsante ad esempio "primary", "danger", ecc.
function ModaleConferma({
  title,
  body,
  labelBottone,
  coloreAzione,
  show,
  handleClose,
  handleOk,
  showAI,
  imageAI,
  titleAI,
  variantAI,
  functionAI,
  modalIcon = <FontAwesomeIcon icon={faTriangleExclamation} />,
}) {
  return (
    <Modal show={show} onHide={handleClose} centered role="dialog" size="lg">
      <Modal.Header className="modalHeader" closeLabel="Chiudi">
        <div className="modalHeaderContent">
          <div className="modalIcon" style={{ color: themeColors.warning, pointerEvents: 'none' }}>
            {modalIcon}
          </div>
          <Modal.Title id="contained-modal-title-vcenter">
            {title}
          </Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>{body}</Modal.Body>
      <Modal.Footer className="modalFooter">
        <Col className="col-lg-auto text-end d-flex align-items-center gap-2">
          <Button variant="grey" onClick={handleClose}>
            Chiudi
          </Button>
          <Button name="tasto-funzione" variant={coloreAzione} onClick={handleOk}>
            {labelBottone}
          </Button>
          {showAI
            ? (
              <Button
                style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                variant={variantAI ?? 'info'}
                name="tasto-funzione"
                onClick={functionAI}
              >
                {imageAI}
                {titleAI ?? 'Info'}
              </Button>
            ) : null}
        </Col>
      </Modal.Footer>
    </Modal>
  );
}

export default ModaleConferma;
